import React from "react"
import starGrey from "../images/star-grey.svg"
import starFill from "../images/star-fill.svg"
import "./reviewCard.less"

export type Review = {
  name: string
  rating: number
  comment: string
}

// The stars are one image to assistive tech - five separate <img> tags would be
// read out one by one without ever saying what the rating is.
const Rating = ({ rating }: { rating: number }) => (
  <div
    className="review-card-stars"
    role="img"
    aria-label={`Įvertinimas: ${rating} iš 5`}
  >
    {[1, 2, 3, 4, 5].map((star) => (
      <img key={star} src={star <= rating ? starFill : starGrey} alt="" aria-hidden="true" />
    ))}
  </div>
)

const ReviewCard = ({ review }: { review: Review }) => (
  <div className="review-card">
    <div className="review-card-body">
      <div className="review-card-name">{review.name}</div>
      <div className="review-card-rating">
        <Rating rating={review.rating} />
      </div>
      <div className="review-card-feedback">{review.comment}</div>
    </div>
  </div>
)

export default ReviewCard
